// Скролер для .index-groups
document.addEventListener('DOMContentLoaded', function () {

    if (document.querySelector('.index-groups') === null) {
        return;
    }

    const categoryLabels = document.querySelectorAll('.index-groups__label-text-category');

    function applyMobileCategoryTruncation() {
        if (!categoryLabels.length) return;

        const isMobile = window.matchMedia('(max-width: 430px)').matches;

        categoryLabels.forEach((el) => {
            if (!el.dataset.fullText) {
                el.dataset.fullText = el.textContent.trim();
            }

            const fullText = el.dataset.fullText;

            if (isMobile && fullText.length > 32) {
                const truncated = fullText.slice(0, 20).trimEnd();
                el.textContent = `${truncated}...`;
            } else {
                el.textContent = fullText;
            }
        });
    }

    const slideContainer = document.querySelector('.index-groups__slides');
    const slides = document.querySelectorAll('.index-groups__slide');
    const progressBar = document.querySelector('.progress');
    const progressHandle = document.querySelector('.progress-state');
    const buttonLeft = document.querySelector('.button-larrow');
    const buttonRight = document.querySelector('.button-rarrow');

    if (!slideContainer || slides.length === 0 || !progressBar || !progressHandle || !buttonLeft || !buttonRight) return;

    const slideWidth = slides[0].offsetWidth;
    const scrollAmount = slideWidth * 1.5;
    const slideContainerWidth = slideContainer.scrollWidth;
    const slideContainerVisibleWidth = slideContainer.offsetWidth;
    const scrollableDistance = slideContainerWidth - slideContainerVisibleWidth;

    const progressBarWidth = progressBar.offsetWidth;
    const progressHandleWidth = progressHandle.offsetWidth;
    const maxHandleScroll = progressBarWidth - progressHandleWidth;

    let currentScroll = 0;

    applyMobileCategoryTruncation();

    function updateProgressHandle() {
        const scrollPercentage = slideContainer.scrollLeft / scrollableDistance;
        const handlePosition = scrollPercentage * maxHandleScroll;
        progressHandle.style.transform = `translateX(${handlePosition}px)`;
    }

    function scrollSlides(direction) {
        currentScroll = Math.min(Math.max(currentScroll + direction * scrollAmount, 0), scrollableDistance);
        slideContainer.scrollLeft = currentScroll;
        updateProgressHandle();
    }

    buttonLeft.addEventListener('click', function () {
        scrollSlides(-1);
    });

    buttonRight.addEventListener('click', function () {
        scrollSlides(1);
    });

    let isDraggingHandle = false;
    let startX = 0;
    let startLeft = 0;

    // Перетаскивание прогресс-ползунка
    progressHandle.addEventListener('mousedown', function (e) {
        isDraggingHandle = true;
        startX = e.clientX;
        startLeft = parseFloat(progressHandle.style.transform.replace('translateX(', '').replace('px)', '')) || 0;
        document.body.classList.add('no-select'); // Убирает выделение текста
    });

    document.addEventListener('mousemove', function (e) {
        if (!isDraggingHandle) return;

        const deltaX = e.clientX - startX;
        const newLeft = Math.min(Math.max(startLeft + deltaX, 0), maxHandleScroll); // Ограничение в пределах прогресс-бара
        progressHandle.style.transform = `translateX(${newLeft}px)`;

        const scrollPercentage = newLeft / maxHandleScroll;
        currentScroll = scrollPercentage * scrollableDistance;
        slideContainer.scrollLeft = currentScroll; // Обновление позиции прокрутки содержимого
    });

    document.addEventListener('mouseup', function () {
        isDraggingHandle = false;
        document.body.classList.remove('no-select');
    });

    // Прокрутка при клике на progress-bar
    progressBar.addEventListener('click', function (e) {
        if (isDraggingHandle) return; // Исключаем конфликт при перетаскивании
        const clickPositionX = e.offsetX;
        const clickPercentage = clickPositionX / progressBarWidth;
        const newScrollPosition = clickPercentage * scrollableDistance;

        slideContainer.scrollLeft = newScrollPosition;
        currentScroll = newScrollPosition;
        updateProgressHandle();
    });

    // Синхронизация, если скроллит сам контейнер
    slideContainer.addEventListener('scroll', function () {
        currentScroll = slideContainer.scrollLeft;
        updateProgressHandle();
    });

    let resizeTimer = null;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(applyMobileCategoryTruncation, 100);
    });
});
